/* eslint-disable import/prefer-default-export */
export enum SmsTemplateTags {
  PRACTICE_MESSAGE = 'practiceMessage',
  ANONYMOUS_NONREG_MESSAGE = 'nonregChat',
  INVITATION_PATIENT_CALL = 'autoCallerInvitation',
  INVITATION_PATIENT_MANUAL = 'patientInvitation',
  INVITATION_PHYSICIAN = 'colleagueInvitation',
  VIDEO_INVITATION = 'videoInvitation',
  VIDEO_INVITATION_ANONYMOUS = 'videoInvitationAnonym',
  VIDEO_CANCELLATION = 'videoCancellation',
  VIDEO_CANCELLATION_ANONYMOUS = 'videoCancellationAnonym',
  VIDEO_CHANGE = 'videoChange',
  VIDEO_CHANGE_ANONYMOUS = 'videoChangeAnonym',
}
